import React from 'react';
import { FormattedMessage } from 'react-intl';

export const Header = () => {
  return (
    <div>
      <div>
        <FormattedMessage
          id="ClauseLibraryPage.header.searchInput"
          defaultMessage="Search input"
          description="Label for the search input field in the clause library header"
        />
      </div>
      <div>
        <FormattedMessage
          id="ClauseLibraryPage.header.filters"
          defaultMessage="Filters"
          description="Label for the filters section in the clause library header"
        />
      </div>
    </div>
  );
};
